<template>
  <div class="listBox">
    <ul class="sBox">
      <li style="display: flex; align-items: center; gap: 10px">
        <el-button type="primary" :icon="Plus" link
          @click="delete state.selectId; state.showCompile = true;"
          v-if="$store.state.loginUser?.IsAdmin || $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_添加')">
          添加时段
        </el-button>
        <el-button :icon="List" link @click="state.showBatchSet = true;"
          v-if="$store.state.loginUser?.IsAdmin || $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_编辑')">
          批量设置
        </el-button>
        <el-date-picker v-model="state.filterDate" type="date" placeholder="按日期过滤" value-format="YYYY-MM-DD"
          clearable style="width: 160px" @change="onLoad" />
      </li>
    </ul>
    <ul class="tBox">
      <el-table :data="state.tableData" v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)">
        <el-table-column label="#" width="50" type="index" align="center" />
        <el-table-column label="日期" width="110" align="center">
          <template #default="{ row }">{{ formatDate(row.RiQi) }}</template>
        </el-table-column>
        <el-table-column label="" width="80" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.TcId > 0" type="success" size="small">套餐专属</el-tag>
            <el-tag v-else type="info" size="small">规则共享</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="时段名称" prop="ShiDuanMc" min-width="150" />
        <el-table-column label="开始时间" width="100" align="center">
          <template #default="{ row }">{{ formatTime(row.Kssj) }}</template>
        </el-table-column>
        <el-table-column label="结束时间" width="100" align="center">
          <template #default="{ row }">{{ formatTime(row.Jzsj) }}</template>
        </el-table-column>
        <el-table-column prop="Zkc" label="总库存" width="90" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column prop="Yssl" label="已售" width="80" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column prop="Sykc" label="剩余" width="80" align="center" :formatter="$tab_NumberFormat" />
        <el-table-column prop="Px" label="排序" width="70" align="center" />
        <el-table-column label="启用" width="70" align="center">
          <template #default="{ row }">
            <el-switch v-model="row.IsQy" @change="onChange(row)" size="small" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center" className="tabBtn">
          <template #default="{ row }">
            <el-button type="primary" :icon="Edit" link
              @click="state.selectId = row.Id; state.showCompile = true;"
              v-if="$store.state.loginUser?.IsAdmin || $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_编辑')">编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row.Id)"
              v-if="$store.state.loginUser?.IsAdmin || $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_删除')">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <!-- 编辑弹框 -->
    <transition name="el-zoom-in-center">
      <c_popup v-if="state.showCompile" :title="(state.selectId ? '修改' : '添加') + '时段'" width="420px" @close="state.showCompile = false">
        <c_MenPiaoShiDuanCompile @close="state.showCompile = false; onLoad();" :id="state.selectId" :spId="spId" :gzId="gzId" :tcId="tcId">
        </c_MenPiaoShiDuanCompile>
      </c_popup>
    </transition>
    <!-- 批量设置弹框 -->
    <transition name="el-zoom-in-center">
      <c_popup v-if="state.showBatchSet" title="批量设置时段库存" width="80vw" @close="state.showBatchSet = false">
        <c_MenPiaoShiDuanKuCun :spId="spId" :gzId="gzId" :tcId="tcId" @close="state.showBatchSet = false; onLoad();">
        </c_MenPiaoShiDuanKuCun>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { Edit, Delete, Plus, List } from "@element-plus/icons-vue";
import { menpiao_shiduan_list, menpiao_shiduan_delete, menpiao_shiduan_change } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

export default {
  props: { spId: Number, gzId: Number, tcId: Number },
  setup(props) {
    const state = reactive({ tableData: [], filterDate: '' });
    onMounted(() => { onLoad(); });

    const onLoad = () => {
      if (props.spId) {
        delete state.tableData;
        menpiao_shiduan_list(props.spId, state.filterDate || null, props.gzId, props.tcId).then((res) => {
          if (res.status == 200) state.tableData = res.data;
        });
      }
    };

    const formatDate = (val) => {
      if (!val) return '';
      if (typeof val === 'string') return val.substring(0, 10);
      return val;
    };

    const formatTime = (val) => {
      if (!val) return '';
      if (typeof val === 'string') return val.substring(0, 5);
      return val;
    };

    const onChange = (row) => {
      menpiao_shiduan_change(row.Id, row.IsQy).then((res) => {
        if (res.status == 200) { /* success */ }
        else { row.IsQy = !row.IsQy; onLoad(); }
      });
    };

    const onDelete = (id) => { confirm_func(menpiao_shiduan_delete, id, onLoad); };

    return { state, Edit, Delete, Plus, List, onLoad, formatDate, formatTime, onChange, onDelete };
  },
};
</script>
<style scoped></style>
